
const Upcoming = ({title}: {title: string})=>{
    return(
        <div style={{margin: '20px', fontWeight: '500'}}>
            {title} 
        </div>
    );
}
export default Upcoming; 